import React, { useEffect, useState } from "react";
import style from "../../styles/instructionview";

export default (props) => {
  const [wistiaHtml, setWistiaHtml] = useState(null);

  useEffect(() => {
    setWistiaHtml(getHtml(props.wistiaVideo.id));
  }, []);

  const getHtml = (videoId) => {
    let html = `<!DOCTYPE html>
                <html style="padding: 0; margin:0;">
                  <body>
                    <script src="https://fast.wistia.com/embed/medias/${videoId}.jsonp" async></script>
                    <script src="https://fast.wistia.com/assets/external/E-v1.js" async></script>
                    <div class="wistia_embed wistia_async_${videoId}" style="height:350px;border-radius:8px;">&nbsp;</div>
                  </body>
                </html>`;
    return html;
  };
  return (
    <div style={style.vidPlayer}>
      {wistiaHtml != null && (
        <iframe
          height="500px"
          width="500px"
          frameborder="0"
          scrolling="no"
          style={style.vidPlayer}
          title="Embeded Wistia Video"
          srcdoc={wistiaHtml}
        />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/WistiaAsyncVideo.js